export default "__VITE_ASSET__Cmv6dudb__"